var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** An error from the REST API. */
export class ApiError extends Error {
    constructor(status, message, details) {
        super(message);
        this.status = status;
        this.details = details;
    }
}
/**
 * Creates a wrapper around window.fetch for most common REST API requests.
 * @param baseUrl The base URL of the API, i.e. https://api.cubeadmin.center
 * @param baseHeaders The base headers of each request, i.e. {Authorization: "Bearer XXXX"}
 */
export function createApiFetcher(baseUrl, baseHeaders) {
    function fetch(path, options) {
        return __awaiter(this, void 0, void 0, function* () {
            options = options || {};
            options.headers = Object.assign(Object.assign({}, baseHeaders), options.headers);
            const response = yield window.fetch(`${baseUrl}${path}`, options);
            yield checkOkay(response);
            return response;
        });
    }
    function fetchJson(path, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(path, options);
            return yield response.json();
        });
    }
    return {
        fetch,
        fetchJson,
        get: fetchJson,
        del: (path, body) => fetch(path, createJsonRequest("delete", body)),
        put: (path, body) => fetch(path, createJsonRequest("put", body)),
        post: (path, body) => fetch(path, createJsonRequest("post", body)),
        patch: (path, body) => fetch(path, createJsonRequest("PATCH", body)),
    };
}
function checkOkay(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!response.ok) {
            const { message, details } = yield tryExtractErrorMessage(response);
            throw new ApiError(response.status, message, details);
        }
    });
}
function tryExtractErrorMessage(response) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const error = yield response.json();
            if (error && error.error && error.message) {
                return {
                    message: error.error,
                    details: error.message,
                };
            }
        }
        catch (parseError) {
        }
        return {
            message: response.statusText,
        };
    });
}
/**
 * Creates a query string from one or more objects containing key value pairs.
 * @param args
 */
export function createQueryString(...args) {
    const allArgs = args.reduce((acc, curr) => {
        const currArgs = Object.entries(curr)
            .filter(([_, value]) => typeof value != "undefined" && value !== null)
            .flatMap(([key, value]) => (Array.isArray(value) ? value : [value])
            .map(value => [key, `${value}`]));
        return acc.concat(currArgs);
    }, []);
    return new URLSearchParams(allArgs).toString();
}
export function createJsonRequest(method, body) {
    return Object.assign({ method: method }, getBodyRequestInit(body));
}
function getBodyRequestInit(body) {
    if (typeof body !== "undefined") {
        return {
            body: JSON.stringify(body),
            headers: {
                "content-type": "application/json",
            },
        };
    }
    else {
        return {
            body: null,
        };
    }
}
//# sourceMappingURL=fetch.js.map